module.exports = __webpack_public_path__ + "img/katarina_outside_6.f7908bf2.jpg";